package one.healthium.log_period.ui.utils

import androidx.compose.runtime.Immutable
import kotlinx.datetime.LocalDate

@Immutable
internal data class LogPeriodUiState (
    val periodDays: List<LocalDate>
)